import React from 'react'
import { Typography } from 'antd'
import './MyCompany.css'
import GoogleReviews from './GoogleReviews'

const { Text } = Typography

function MyCompany({ 
  aboutInfo, 
  loanOfficerEmail, 
  isMobile,
  companyInfo: {
    Name,
    Address,
    Banner,
    Introduction,

  },
  customerID
}) {
    if (isMobile) {
        return (
            <div className="my-company-page">
                <div className="my-company-title">My company</div>

                <img
                    src={aboutInfo.companyLogo || '/images/my-company.svg'}
                    alt="Company Logo"
                    className="company-logo"
                />

                {/* Content */}
                <div style={{ marginTop: '16px' }}>
                    {/* Company name heading */}
                    <Text className="company-name">
                      {customerID === "googain" || customerID === "gmcc"? (
                        Name
                        // aboutInfo.companyName
                      ):(
                        aboutInfo.companyName
                      )}
                    </Text>

                    {/* Company title */}
                    <Text className="company-title">
                      {customerID === "googain" || customerID === "gmcc"? (
                        Banner
                      ):(
                        aboutInfo.banner
                      )}
                    </Text>

                    {/* Company description */}
                    <Text className="company-description">
                      {customerID === "googain" || customerID === "gmcc"? (
                        Introduction
                      ):(
                        aboutInfo.companyIntroduction
                      )}
                    </Text>
                </div>
                {customerID === "googain" || customerID === "gmcc" && <div>
                  <GoogleReviews 
                    companyName={Name}
                    companyAddress={Address}
                  />
                </div>}
            </div>
        )
    }

    return (
        <div className="my-company-page">
            <div className="my-company-title">My company</div>

            <div className="my-company-content">
                {/* Left Column - Logo */}
                <div className="logo-column">
                    <img
                        src={aboutInfo.companyLogo || '/images/my-company.svg'}
                        alt="Company Logo"
                        className="company-logo"
                    />
                </div>

                {/* Right Column - Content */}
                <div style={{ flex: '1' }}>
                    {/* Company name heading */}
                    <Text className="company-name">
                      {customerID === "googain" || customerID === "gmcc"? (
                        Name
                      ):(
                        aboutInfo.companyName
                      )}
                    </Text>
                    {/* Company title */}
                    <Text className="company-title">
                      {customerID === "googain" || customerID === "gmcc"? (
                        Banner
                      ):(
                        aboutInfo.banner
                      )}
                    </Text>
                    {/* Company description */}
                    <Text className="company-description">
                      {customerID === "googain" || customerID === "gmcc"? (
                        Introduction
                      ):(
                        aboutInfo.companyIntroduction
                      )}
                    </Text>

                    {/* View company button */}
                    {/*{aboutInfo.companyLink !== "" && (<button
            className="view-company-button"
            onClick={() => {
              window.open(
                aboutInfo.companyLink.includes('http')
                  ? aboutInfo.companyLink
                  : 'https://' + aboutInfo.companyLink,
                '_blank'
              );
            }}
          >
            View our company
          </button>)} */}
                </div>
            </div>
            {customerID === "googain" && <div>
              <GoogleReviews 
                companyName={Name}
                companyAddress={Address}
              />
            </div>}
        </div>
    )
}

export default MyCompany
